import Loader from './loader/Loader';

// @ts-ignore
window.LOADER = new Loader()
